// extracted by mini-css-extract-plugin
export default {"title":"AppointmentQuickSelection_title__0DkWA","details":"AppointmentQuickSelection_details__bA1Gh","hide":"AppointmentQuickSelection_hide__y9-D2"};